import { ButtonBase, InputAdornment } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
const InputSearchProps = {
  endAdornment: (
    <InputAdornment position="end">
      <ButtonBase
        type="submit"
        style={{
          rotate: "180deg",
          height: "40px",
          width: "50px",
          padding: "0px",
          borderRadius: "5px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          courser: "pointer",
          cursor: "pointer",
        }}
      >
        <SendIcon sx={{ color: "#000" }} />
      </ButtonBase>
    </InputAdornment>
  ),
};

export default InputSearchProps;
